import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectDraftInfoState = (state: AppState) => state.draftInfo;
export const selectDraftInfo = createSelector(selectDraftInfoState, state => state.draftList);
export const selectDraftInfoStatus = createSelector(selectDraftInfoState, state => state.status);
